import React from 'react';

const ChevriDir = ({ onClick }) => {
  return (
    <svg
      width='77'
      height='77'
      viewBox='0 0 77 77'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      onClick={onClick}
    >
      <path
        d='M70.0526 38.7121C70.2319 21.224 56.2003 6.90179 38.7122 6.72251C21.2241 6.54323 6.90185 20.5748 6.72257 38.0629C6.54329 55.551 20.5749 69.8732 38.063 70.0525C55.5511 70.2318 69.8733 56.2002 70.0526 38.7121Z'
        stroke='white'
        strokeWidth='2'
      />
      <path
        d='M33.508 51.0049L46.3038 38.4687L33.7677 25.6729'
        stroke='white'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default ChevriDir;
